import React, { useEffect, useState } from 'react'
import { getAllSitesNewAPI, getGroups, getInactiveSitesAPI } from '../../Api Methods/Api'
import { useDispatch, useSelector } from 'react-redux'
import { Await } from 'react-router-dom'
import AllSitesSearchBar from '../AllSites/allSitesSearchBar'
import DevicesList from '../../components/GridList/DevicesList'
import DeviceLoadingGrid from '../../components/GridList/DeviceLoadingGrid'
import StatCard from '../../components/UI/Stats/StatCard'
import { serviceActions } from '../../store/service-Slice'
import DataManager from '../../hooks/DataManager'
import mixpanel from 'mixpanel-browser'

const ActiveSites = () => {
    const dispatch = useDispatch()
    const client = useSelector(state => state.auth.client)
    const token = useSelector(state => state.auth.token)
    const dataManager = new DataManager()
    const apiData = { token, client }

    const [activeSites, setActiveSites] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isLoadingStats, setIsLoadingStats] = useState(true)
    const [resultCount, setResultCount] = useState(0)
    const [totalPages, setTotalPages] = useState([])
    const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
    const [pageSize, setPageSize] = useState(dataManager.getItem('pageSize'))
    const [update, setUpdate] = useState(0)
    const [showMassSettings, setShowMassSettings] = useState(false)
    const [submit, setSubmit] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const [groups, setGroups] = useState([])


    // Filter state
    const [online, setOnline] = useState(0)
    const [offline, setOffline] = useState(0)
    const [deviceTag, setDeviceTag] = useState(null)
    const [cloudController, setCloudController] = useState(0)
    const [davantis, setDavantis] = useState(0)
    const [g2cc, setG2cc] = useState(0)
    const [ESP, setESP] = useState(0)
    const [RPi, setRPi] = useState(0)
    const [groupName, setGroupName] = useState(null)
    const [includeSubgroups, setIncludeSubgroups] = useState(0)
    const [noTag, setNoTag] = useState(0)
    const [noUsers, setNoUsers] = useState(0)
    const [liveViewStatus, setLiveViewStatus] = useState(-1)
    const [scheduleOnly, setScheduleOnly] = useState(-1)
    const [hasAjax, setHasAjax] = useState(0)
    const [hasHik, setHasHik] = useState(0)
    const [hasAIBOX, setHasAIBOX] = useState(0)
    const [hasDahua, setHasDahua] = useState(0)
    const [hasCamect, setHasCamect] = useState(0)
    const [hasPadlock, setHasPadlock] = useState(0)
    const [hasKeybox, setHasKeybox] = useState(0)
    const [hasGateway, setHasGateway] = useState(0)
    const [hasSigfox, setHasSigfox] = useState(0)
    const [hasIndSigfox, setHasIndSigfox] = useState(0)
    const [hasEfento, setHasEfento] = useState(0)
    const [hasTeltonika, setHasTeltonika] = useState(0)
    const [hasSchedules, setHasSchedules] = useState(0)
    const [hasTempSchedules, setHasTempSchedules] = useState(0)
    const [activePinCount, setActivePinCount] = useState(-1)
    const [ruleV2Owner, setRuleV2Owner] = useState(0)
    const [ruleV2Parent, setRuleV2Parent] = useState(0)
    const [ruleV2Affected, setRuleV2Affected] = useState(0)
    const [connectionIssues, setConnectionIssues] = useState(0)
    const [hasCamerasLinked, setHasCamerasLinked] = useState(-1)
    const [billable, setBillable] = useState(-1)
    const [billingFrequency, setBillingFrequency] = useState(-1)
    const [billedTo, setBilledTo] = useState(-1)

    // Sort state
    const [sortAsc, setSortAsc] = useState(0)
    const [sUserCount, setSUserCount] = useState(0)
    const [sCreated, setSCreated] = useState(1)
    const [sFirmware, setSFirmware] = useState(0)
    const [sName, setSName] = useState(0)
    const [sCameraCount, setSCameraCount] = useState(0)
    const [sDateOfSale, setSDateOfSale] = useState(0)
    const [sLastInvoice, setSLastInvoice] = useState(0)
    const [sDateMadeActive, setSDateMadeActive] = useState(0)

    const GetGroups = async () => {
        try {
            const listOptions = await getGroups(apiData, dispatch)
            setGroups(listOptions || [])
        } catch {
            setGroups([])
        }
    }

    useEffect(() => {
        GetGroups()
        mixpanel.track('Active sites tab visited', { user: localStorage.getItem('email') })
    }, [])

    useEffect(() => {
        setIsLoading(true)
        const offset = pageSize * (pageFetchedIndex - 1)
        const body = {
            active: 1,
            pageSize,
            pageOffset: offset,
            searchTerm,
            online: Number(online),
            offline: Number(offline),
            deviceTag,
            cloudController: Number(cloudController),
            davantis: Number(davantis),
            g2cc: Number(g2cc),
            ESP: Number(ESP),
            RPi: Number(RPi),
            groupName,
            includeSubgroups: Number(includeSubgroups),
            noTag: Number(noTag),
            noUsers: Number(noUsers),
            liveViewStatus: Number(liveViewStatus),
            scheduleOnly: Number(scheduleOnly),
            hasAjax: Number(hasAjax),
            hasHik: Number(hasHik),
            hasAIBOX: Number(hasAIBOX),
            hasDahua: Number(hasDahua),
            hasCamect: Number(hasCamect),
            hasPadlock: Number(hasPadlock),
            hasKeybox: Number(hasKeybox),
            hasGateway: Number(hasGateway),
            hasSigfox: Number(hasSigfox),
            hasIndSigfox: Number(hasIndSigfox),
            hasEfento: Number(hasEfento),
            hasTeltonika: Number(hasTeltonika),
            hasSchedules: Number(hasSchedules),
            hasTempSchedules: Number(hasTempSchedules),
            activePinCount: Number(activePinCount),
            sortAsc: Number(sortAsc),
            sUserCount: Number(sUserCount),
            sCreated: Number(sCreated),
            sFirmware: Number(sFirmware),
            sName: Number(sName),
            sCameraCount: Number(sCameraCount),
            ruleV2Owner: Number(ruleV2Owner),
            ruleV2Parent: Number(ruleV2Parent),
            ruleV2Affected: Number(ruleV2Affected),
            connectionIssues: Number(connectionIssues),
            hasCamerasLinked: Number(hasCamerasLinked),
            billable: Number(billable),
            billingFrequency: Number(billingFrequency),
            billedTo: Number(billedTo),
            sDateOfSale: Number(sDateOfSale),
            sLastInvoice: Number(sLastInvoice),
            sDateMadeActive: Number(sDateMadeActive),
        }

        const fetch = async () => {
            const response = await getAllSitesNewAPI(apiData, body, dispatch)
            setActiveSites(response.data[1])
            setResultCount(response.data[0][0].totalCount)
            setTotalPages(Math.ceil(response.data[0][0].totalCount / pageSize))
            dispatch(serviceActions.setActiveSitesTableData(response.data[1]))
            setIsLoading(false)
            setIsLoadingStats(false)
        }
        fetch()
    }, [submit, pageSize, pageFetchedIndex, online, offline, deviceTag, cloudController, davantis, g2cc, ESP, RPi, groupName, includeSubgroups, noTag, noUsers, liveViewStatus, scheduleOnly, hasAjax, hasHik, hasAIBOX, hasDahua, hasCamect, hasPadlock, hasKeybox, hasGateway, hasSigfox, hasIndSigfox, hasEfento, hasTeltonika, hasSchedules, hasTempSchedules, activePinCount, sortAsc, sUserCount, sCreated, sFirmware, sName, sCameraCount, ruleV2Owner, ruleV2Parent, ruleV2Affected, connectionIssues, hasCamerasLinked, billable, billingFrequency, billedTo, sDateOfSale, sLastInvoice, sDateMadeActive])

    useEffect(() => {
        const delay = setTimeout(() => setSubmit(prev => !prev), 400)
        return () => clearTimeout(delay)
    }, [searchTerm])

    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 'var(--gap-md)' }}>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '12px', width: '250px', alignContent: 'flex-start', alignItems: 'flex-start', alignSelf: 'start' }}>
                <StatCard title="Active sites" value={resultCount} isLoading={isLoadingStats} />
            </div>

            <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-start', alignItems: 'center' }}>
            <AllSitesSearchBar
                placeholder="Search..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                showFilterButton={true}
                groups={groups}
                isActiveSites={true}
                online={online} setOnline={setOnline}
                offline={offline} setOffline={setOffline}
                deviceTag={deviceTag} setDeviceTag={setDeviceTag}
                cloudController={cloudController} setCloudController={setCloudController}
                davantis={davantis} setDavantis={setDavantis}
                G2CC={g2cc} setG2CC={setG2cc}
                ESP={ESP} setESP={setESP}
                RPi={RPi} setRPi={setRPi}
                groupName={groupName} setGroupName={setGroupName}
                submit={submit} setSubmit={setSubmit}
                noTag={noTag} setNoTag={setNoTag}
                noUsers={noUsers} setNoUsers={setNoUsers}
                liveViewStatus={liveViewStatus} setLiveViewStatus={setLiveViewStatus}
                scheduleOnly={scheduleOnly} setScheduleOnly={setScheduleOnly}
                hasAjax={hasAjax} setHasAjax={setHasAjax}
                hasHik={hasHik} setHasHik={setHasHik}
                hasAIBOX={hasAIBOX} setHasAIBOX={setHasAIBOX}
                hasDahua={hasDahua} setHasDahua={setHasDahua}
                hasCamect={hasCamect} setHasCamect={setHasCamect}
                active={1} setActive={() => {}}
                hasPadlock={hasPadlock} setHasPadlock={setHasPadlock}
                hasKeybox={hasKeybox} setHasKeybox={setHasKeybox}
                hasGateway={hasGateway} setHasGateway={setHasGateway}
                hasSigfox={hasSigfox} setHasSigfox={setHasSigfox}
                hasIndSigfox={hasIndSigfox} setHasIndSigfox={setHasIndSigfox}
                hasEfento={hasEfento} setHasEfento={setHasEfento}
                hasTeltonika={hasTeltonika} setHasTeltonika={setHasTeltonika}
                hasSchedule={hasSchedules} setHasSchedule={setHasSchedules}
                hasTempSchedules={hasTempSchedules} setHasTempSchedules={setHasTempSchedules}
                activePinCount={activePinCount} setActivePinCount={setActivePinCount}
                sortAsc={sortAsc} setSortAsc={setSortAsc}
                sUserCount={sUserCount} setSUserCount={setSUserCount}
                sCreated={sCreated} setSCreated={setSCreated}
                sFirmware={sFirmware} setSFirmware={setSFirmware}
                sName={sName} setSName={setSName}
                sCameraCount={sCameraCount} setSCameraCount={setSCameraCount}
                ruleV2Owner={ruleV2Owner} setRuleV2Owner={setRuleV2Owner}
                ruleV2Parent={ruleV2Parent} setRuleV2Parent={setRuleV2Parent}
                ruleV2Affected={ruleV2Affected} setRuleV2Affected={setRuleV2Affected}
                connectionIssues={connectionIssues} setConnectionIssues={setConnectionIssues}
                hasCamerasLinked={hasCamerasLinked} setHasCamerasLinked={setHasCamerasLinked}
                includeSubgroups={includeSubgroups} setIncludeSubgroups={setIncludeSubgroups}
                billable={billable} setBillable={setBillable}
                billingFrequency={billingFrequency} setBillingFrequency={setBillingFrequency}
                billedTo={billedTo} setBilledTo={setBilledTo}
                sDateOfSale={sDateOfSale} setSDateOfSale={setSDateOfSale}
                sLastInvoice={sLastInvoice} setSLastInvoice={setSLastInvoice}
                sDateMadeActive={sDateMadeActive} setSDateMadeActive={setSDateMadeActive}
            />
            </div>

             <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                    {isLoading && (
                            <p style={{ margin: 0 }}>Updating…</p>
                        ) || <p style={{ margin: 0 }}>Total results: {resultCount}</p>
                    }
                </div>

            <Await resolve={activeSites}>
                {(loadedActiveSites) => (
                    isLoading ? (
                        <div style={{ display: 'flex', width: '100%' }}>
                            <DeviceLoadingGrid CardCount={20} />
                        </div>
                    ) : (
                        <DevicesList
                            devices={loadedActiveSites}
                            filtering=""
                            hideControls={false}
                            totalPages={totalPages}
                            setTotalPages={setTotalPages}
                            pageFetchedIndex={pageFetchedIndex}
                            setPageFetchedIndex={setPageFetchedIndex}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            totalDevices={resultCount}
                            groupMode={false}
                            update={update}
                            setUpdate={setUpdate}
                            offlineOnly={false}
                            isSortable={true}
                            showMassSelect={true}
                            showMassSettings={showMassSettings}
                            setShowMassSettings={setShowMassSettings}
                        />
                    )
                )}
            </Await>
        </div>
    )
}

export default ActiveSites
